<template>
  <div class="nav__container">
    <div class="nav__container-inner">
      <router-link :to="`/${$route.params.id || ''}/`" class="nav__logo-link">
        <img src="/logo.svg" alt="Assurity Logo" class="nav__logo" />
      </router-link>
      <button id="open-menu" class="nav__open-btn nav__btn" :class="{'nav__open-btn--hidden': menuOpen}" @click="toggleMenu()" ref="navOpen">
        <span class="nav__icon material-icons-outlined">menu</span>
        <span class="sr-only">Open Menu</span>
      </button>
      <transition name="fade">
        <nav class="nav__nav" id="main-menu" v-show="menuOpen">
          <ul class="nav__list" v-if="proposal && products && products.length">
            <li class="nav__list-item">
              <router-link :to="`/${$route.params.id}/`" class="nav__list-link" @keydown.native="focusLast($event);" ref="navFirst" @click.native="toggleMenu()">
                Home
              </router-link>
            </li>
            <li class="nav__list-item" v-for="product in products" :key="product.Id">
              <router-link :to="`/${$route.params.id}/${getProduct(product).id}`" class="nav__list-link" @click.native="toggleMenu()">{{ getProduct(product).name }}</router-link>
            </li>
            <li class="nav__list-item">
              <button id="close-menu" class="nav__close-btn nav__btn" @click="toggleMenu()" @keydown="focusFirst($event)" ref="navLast">
                <span class="nav__icon material-icons-outlined">close</span>
                <span class="sr-only">Close Menu</span>
              </button>
            </li>
          </ul>
        </nav>
      </transition>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      menuOpen: false,
    };
  },
  computed: {
    ...mapGetters({
      products: "getProducts",
      proposal: "getProposal",
    }),
  },
  methods: {
    getProduct(product) {
      const simpleProduct = {};
      switch (product.Id) {
        case "AccidentExpense":
          simpleProduct.name = "Accident Expense";
          simpleProduct.id = "accident-expense";
          break;
        case "CriticalIllness":
          simpleProduct.name = "Critical Illness";
          simpleProduct.id = "critical-illness";
          break;
        case "HospitalIndemnity":
          simpleProduct.name = "Hospital Indemnity";
          simpleProduct.id = "hospital-indemnity";
          break;
        case "DisabilityIncome":
          simpleProduct.name = "Disability Income";
          simpleProduct.id = "disability-income";
          break;
        case "TermLife":
          simpleProduct.name = "Term Life";
          simpleProduct.id = "term-life";
          break;
        case "WholeLife":
          simpleProduct.name = "Whole Life";
          simpleProduct.id = "whole-life";
          break;
      }
      return simpleProduct;
    },
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
      window.setTimeout(() => {
        if (this.menuOpen) {
          this.$refs.navLast.focus();
        } else {
          this.$refs.navOpen.focus();
        }
      }, 1);
    },
    focusFirst($event) {
      if (!$event.shiftKey && $event.key === 'Tab') {
        $event.preventDefault();
        this.$refs.navFirst.$el.focus();
      }
    },
    focusLast($event) {
      if ($event.shiftKey && $event.key === 'Tab') {
        $event.preventDefault();
        this.$refs.navLast.focus();
      } 
    }
  },
};
</script>
<style lang="scss" scoped>
.nav {
  &__container {
    background: $red;
  }
  &__container-inner {
    max-width: 1920px;
    padding: 10px 100px;
    display: flex;
    max-width: 1580px;
    margin: 0 auto;
  }
  &__logo {
    max-width: 125px;
  }
  &__logo-link {
    flex: 1 1 auto;
    line-height: 0;
    text-decoration: none;
  }
  &__nav {
    position: fixed;
    bottom: 0;
    right: 15px;
    background: $red;
    padding: 30px 30px 60px;
    z-index: 9;
    border: 1px solid $white;
    border-bottom: none;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }
  &__list {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  &__list-item {
    & + & {
      margin-top: 15px;
    }
  }
  &__list-link {
    color: $white;
    font-size: 1.125rem;
  }
  &__btn {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5px;
    width: 50px;
    height: 50px;
    background: $red;
    border: none;
    cursor: pointer;
    bottom: 15px;
    border: 2px solid $white;
    border-radius: 50%;
  }
  &__open-btn {
    position: fixed;
    z-index: 8;
    right: 30px;
  }
  &__close-btn {
    position: absolute;
    margin-left: auto;
    right: 15px;
  }
  &__icon {
    color: $white;
    font-size: 1.75rem;
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .2s, transform .2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(10%);
}
</style>
